import React from 'react';
import Moment from 'react-moment';
import {Link} from 'react-router-dom';
import Loading from '../Loading.js';
import ResponsiveTable from '../Table/ResponsiveTable.js';
import {Badge} from 'react-bootstrap';

class SessionTable extends React.Component {

    getProposalName(row) {
        return row.Proposal_proposalCode + row.Proposal_ProposalNumber;
    }
    /**
 * TODO: this BM29, CM01 should come from a config file as defined on https://github.com/ispyb/EXI/blob/master/mx/config.js
 *
 */
    dateFormatter(cell, row, rowIndex, extraData) {
        if (!extraData.isEmpty(row)) {
            if (cell != null) {
                var link = '/sessions/mx/proposal/' + extraData.getProposalName(row) + '/session/' + row.sessionId + '/datasets';
                if (row.beamLineName.toUpperCase() === 'BM29') {
                    link = '/sessions/saxs/proposal/' + extraData.getProposalName(row) + '/session/' + row.sessionId + '/experiments';
                }
                if (row.beamLineName.toUpperCase() === 'CM01') {
                    link = '/sessions/em/proposal/' + extraData.getProposalName(row) + '/session/' + row.sessionId + '/datasets';
                }
                // <Moment parse = 'LLL'  format = 'DD/MM/YYYY hh:mm' >${cell}</Moment>
                return (
                    <Link
                        to={link}
                        onClick={() => {
                        extraData
                            .props
                            .setActiveSession(row.sessionId, cell)
                    }}>
                        <Moment parse='LLL' format='DD/MM/YYYY'>${cell}</Moment>
                    </Link>
                );
            }
        }
        return <Moment parse='LLL' format='DD/MM/YYYY'>${cell}</Moment>;
    }

    statsFormatter(cell, row, rowIndex, extraData) {
        if (cell != null) {
            if (cell !== 0) {
                return <Badge>{cell}</Badge>;
            }
        }
        return null;
    }
    proposalFormatter(cell, row, rowIndex, extraData) {
        if (cell != null) {
            return extraData.getProposalName(row);
        }
    }

    collapsedFormatter(cell, row, rowIndex, extraData) {
        if (cell != null) {
            return extraData.getProposalName(row);
        }
    }

    getHeaderStats() {
        return {
            xs: {
                hidden: true
            },
            sm: {
                hidden: true
            },
            md: {
                width: '30px',
                textAlign: 'center'
            },
            lg: {
                width: '60px',
                textAlign: 'center'
            }
        };
    }
    getColumns() {
        return [
            {
                text: 'id',
                dataField: 'id',
                hidden: true
            }, {
                text: 'Date',
                dataField: 'BLSession_startDate',
                formatter: this.dateFormatter,
                formatExtraData: this,
                responsiveHeaderStyle: {
                    xs: {
                        width: '100px',
                        textAlign: 'center'
                    },
                    sm: {
                        width: '100px',
                        textAlign: 'center'
                    },
                    md: {
                        width: '80px',
                        textAlign: 'center'
                    },
                    lg: {
                        width: '80px',
                        textAlign: 'center'
                    }
                }
            }, {
                text: 'Beamline',
                dataField: 'beamLineName',
                responsiveHeaderStyle: {
                    xs: {
                        width: '60px',
                        textAlign: 'center'
                    },
                    sm: {
                        width: '60px',
                        textAlign: 'center'
                    },
                    md: {
                        width: '60px',
                        textAlign: 'center'
                    },
                    lg: {
                        width: '60px',
                        textAlign: 'center'
                    }
                }
            }, {
                text: 'Proposal',
                dataField: 'Proposal_proposalCode',
                formatter: this.proposalFormatter,
                formatExtraData: this,
                responsiveHeaderStyle: {
                    xs: {
                        width: '60px',
                        textAlign: 'center'
                    },
                    sm: {
                        width: '60px',
                        textAlign: 'center'
                    },
                    md: {
                        width: '60px',
                        textAlign: 'center'
                    },
                    lg: {
                        width: '60px',
                        textAlign: 'center'
                    }
                }
            }, {
                text: 'Local Contact',
                dataField: 'beamLineOperator',
                responsiveHeaderStyle: {
                    xs: {
                        hidden: true
                    },
                    sm: {
                        hidden: true
                    },
                    md: {
                        width: '100px',
                        textAlign: 'center'
                    },
                    lg: {
                        width: '140px',
                        textAlign: 'center'
                    }
                }
            }, {
                text: 'En. Scans',
                dataField: 'energyScanCount',
                formatter: this.statsFormatter,
                responsiveHeaderStyle: this.getHeaderStats(),
                hidden: !this.props.configuration.isMXenabled
            }, {
                text: 'XRF',
                dataField: 'xrfSpectrumCount',
                formatter: this.statsFormatter,
                responsiveHeaderStyle: this.getHeaderStats(),
                hidden: !this.props.configuration.isMXenabled
            }, {
                text: 'Samples',
                dataField: 'sampleCount',
                formatter: this.statsFormatter,
                responsiveHeaderStyle: this.getHeaderStats(),
                hidden: !this.props.configuration.isMXenabled
            }, {
                text: 'Tests',
                dataField: 'testDataCollectionGroupCount',
                formatter: this.statsFormatter,
                responsiveHeaderStyle: this.getHeaderStats(),
                hidden: !this.props.configuration.isMXenabled
            }, {
                text: 'Collects',
                dataField: 'dataCollectionGroupCount',
                formatter: this.statsFormatter,
                responsiveHeaderStyle: this.getHeaderStats(),
                hidden: !this.props.configuration.isMXenabled
            }, {
                text: 'Calibration',
                dataField: 'calibrationCount',
                formatter: this.statsFormatter,
                responsiveHeaderStyle: this.getHeaderStats(),
                hidden: !this.props.configuration.isSAXSenabled
            }, {
                text: 'SC',
                dataField: 'sampleChangerCount',
                formatter: this.statsFormatter,
                responsiveHeaderStyle: this.getHeaderStats(),
                hidden: !this.props.configuration.isSAXSenabled
            }, {
                text: 'HPLC',
                dataField: 'hplcCount',
                formatter: this.statsFormatter,
                responsiveHeaderStyle: this.getHeaderStats(),
                hidden: !this.props.configuration.isSAXSenabled
            }, {
                text: 'Grid Squares',
                dataField: 'EMdataCollectionGroupCount',
                formatter: this.statsFormatter,
                responsiveHeaderStyle: this.getHeaderStats(),
                hidden: !this.props.configuration.isEMenabled
            }, {
                text: 'Comments',
                dataField: 'comments',
                responsiveHeaderStyle: {
                    xs: {
                        hidden: true
                    },
                    sm: {
                        hidden: true
                    },
                    md: {
                        width: '140px'
                    },
                    lg: {
                        width: '20%'
                    }
                }
            }

        ];
    }

    isEmpty(row) {
        function checkNonZero(value) {
            return !value || value === 0;
        }
        return (checkNonZero(row.energyScanCount) && checkNonZero(row.xrfSpectrumCount) && checkNonZero(row.EMdataCollectionGroupCount) && checkNonZero(row.hplcCount) && checkNonZero(row.sampleChangerCount) && checkNonZero(row.calibrationCount) && checkNonZero(row.dataCollectionGroupCount) && checkNonZero(row.testDataCollectionGroupCount) && checkNonZero(row.sampleCount) && checkNonZero(row.xrfSpectrumCount) && checkNonZero(row.energyScanCount));

    }
    render() {        
        if (this.props.sessions.fetching) {
            return <Loading message='Loading sessions'/>;
        }
        const rowStyle = (row, rowIndex) => {
            if (this.isEmpty(row)) {
                return {color: '#B6B6B6', backgroundColor: '#F9F9F9'};
            }
        };

        return <div>
            <ResponsiveTable
                rowStyle={rowStyle}
                pageOptions={{
                sizePerPage: 100
            }}
                search={false}
                keyField='id'
                data={this.props.sessions.data}
                columns={this.getColumns()}/>
        </div>;

    }
}

export default SessionTable;


// WEBPACK FOOTER //
// ./src/components/Session/SessionTable.js